import { Component, OnInit, Input } from '@angular/core';
import { FormValidator } from './../common/services/formValidator.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonConstants } from '../common/utilities/commonConstants';
import { RouteHandlerService } from '../common/services/routeHandler.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { GetGoingCall } from '../getGoingNow/getGoingNow.service';
import { MoreAboutYouCall } from '../questionnaireModule/moreAboutYou/moreAboutYou.service';
import { Formatter } from '../common/services/formatter';
import { AnalyticsService } from '../common/services/device.analytics.service';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';

const ErrorCodes = {
    InvalidMobileOTP: 'InvalidMobileOTP',
    RetryExhausted: 'RetryExhausted'
};
@Component({
    selector: 'app-otp-resume-application',
    templateUrl: './otpResumeApplication.template.html',
    styleUrls: ['./otpResumeApplication.style.scss'],
    providers: [GetGoingCall, MoreAboutYouCall]
})
export class OtpResumeApplicationComponent implements OnInit {
    @Input() public mobileNumber;
    public ResumeApplicationForm: FormGroup;
    public MobileNumber: string;
    public IsErrorOTP: boolean;
    public IsServiceFailure: boolean;
    public ResendOtpExceedFlag = false;
    public ShowOTPField = false;
    public IsMobileValid = false;
    public WrongOtpMsg: string = null;
    public ServiceOTPError: string;
    public incorrectOTP = 0;
    public OTPResend = 0;
    public IsOTPResend = false;
    public MobileOtpTrails = 0;
    public IsCorrectMobile: string = null;
    public ServiceError: string;
    public showLoader = false;
    public MainLoadingText = 'Stay with us. We\'re almost done...';

    healthOtpForm: FormGroup;
    wrongOtpMsg;
    resendOtpExceedFlag;
    mobileOtpTrails;
    resendOTPCount;
    bflJourney: any;
    timerOn: boolean;
    timer;
    setTime;
    public isTimerStarted = false;
    isOtpPasted: boolean;

    constructor(
        public FormValidators: FormValidator,
        private _formBuilder: FormBuilder,
        private _routerService: RouteHandlerService,
        private _sessionStorage: SessionHandlerService,
        private _GetGoingCall: GetGoingCall,
        private _moreAboutYouCall: MoreAboutYouCall,
        private _formatter: Formatter,
        private analyticsService: AnalyticsService,
        private _routeContextProvider: RouteContextProvider
    ) { }
    // On Page Init
    public ngOnInit() {
        let url: any = window.location.pathname;
        url = url.split("/");
        this.bflJourney = url.includes(CommonConstants.QueryParamsKeys.marketplace);
        this.buildHealthOtpForm();

        this.generateOTP(this.onResendOTPReceived);
    }

    private getFormValuesAsPayload(isActivityCall?: boolean) {
        const outputPayload = {};
        outputPayload['mobile'] = this.mobileNumber;
        outputPayload['productCode'] = CommonConstants.LOAN_PRODUCT_CODES.Health_Insurance;
        outputPayload['insProductType'] = CommonConstants.InsProductType;

        return outputPayload;
    }

    generateOTP(callback): void {
        const outputPayload = this.getFormValuesAsPayload();
        outputPayload['otp'] = CommonConstants.DEFAULT_EMPTY_STRING;
        outputPayload['source'] = CommonConstants.SourceTypes.Journey;
        outputPayload['mfa'] = true;
        this._GetGoingCall.postSendMobileOTP(outputPayload).subscribe(
            response => {
                if (!response.errorBean) {
                    this.isTimerStarted = true;
                    this.startClockTimer();
                    callback.call(this, response);
                } else if (CommonConstants.errorCodes.includes(response.errorBean[0].errorCode)) {
                    this.IsOTPResend = false;
                    this.ServiceError = response.errorBean[0].errorMessage;
                }
            },
            err => {

            }
        );
    }

    buildHealthOtpForm() {
        this.healthOtpForm = this._formBuilder.group({
            digit1: ['', Validators.compose([Validators.required])],
            digit2: ['', Validators.compose([Validators.required])],
            digit3: ['', Validators.compose([Validators.required])],
            digit4: ['', Validators.compose([Validators.required])],
            digit5: ['', Validators.compose([Validators.required])],
            digit6: ['', Validators.compose([Validators.required])],
        });


        this.healthOtpForm.valueChanges.subscribe((updatedValue) => {
            this.wrongOtpMsg = null;
            console.log(this.healthOtpForm);
            console.log(this.healthOtpForm.controls['digit1'].valid);

            if (this.healthOtpForm.valid) {
                // this.validateOtp();
            }
        });
    }

    private createOtpPayload() {
        const InsProductType = this._sessionStorage.GetSession(CommonConstants.CookieKeys.InsProductType);
        const outputPayload = {
            "applicationKey": this._sessionStorage.GetSession(CommonConstants.CookieKeys.applicationId),
            "dateOfBirth": null,
            "mobile": this.mobileNumber,
            "otp": this.healthOtpForm.controls['digit1'].value + this.healthOtpForm.controls['digit2'].value +
                this.healthOtpForm.controls['digit3'].value + this.healthOtpForm.controls['digit4'].value +
                this.healthOtpForm.controls['digit5'].value + this.healthOtpForm.controls['digit6'].value,
            "productcatcode": InsProductType ? InsProductType : 'HGI',
            "source": 'journey',
            "stage": null
        }
        return outputPayload;
    }

    public validateOtp() {
        console.log(this.healthOtpForm);
        console.log(this.healthOtpForm);
        if (!this.healthOtpForm.valid) {
            this.wrongOtpMsg = 'Please provide a valid OTP.';
        } else {
            this.IsOTPResend = false;
            const outputPayload = this.createOtpPayload();
            if (this.mobileOtpTrails >= 5) {
                this.resendOtpExceedFlag = true;
            }

            this.showLoader = true;
            this._GetGoingCall.postValidateOTP(outputPayload)
                .subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
                    this.ServiceOTPError = null;
                    if (mtResponse.payload && mtResponse.payload.tokens) {
                        this.wrongOtpMsg = null;
                        const token = mtResponse.payload.tokens[0].token;
                        if (token) {
                            this._sessionStorage.SetSession(CommonConstants.CookieKeys.JWToken, token);
                        }
                        this._sessionStorage.SetSession(CommonConstants.CookieKeys.GuardKey,
                            token.guardKey);
                        this._sessionStorage.SetSession(CommonConstants.CookieKeys.GuardToken,
                            this._formatter.ConvertGuradKeyToGuardToken(token.guardKey));
                        this.navigateToNextTask();
                    }
                    if ((!!mtResponse.errorBean && CommonConstants.errorCodes.includes(mtResponse.errorBean[0].errorCode)) || mtResponse.error.errorBean[0].errorCode) {
                        this.mobileOtpTrails++;
                        if (mtResponse.errorBean && mtResponse.errorBean[0].errorMessage)
                            this.ServiceOTPError = mtResponse.errorBean[0].errorMessage;
                        if (mtResponse.error && mtResponse.error.errorBean && mtResponse.error.errorBean[0].errorCode)
                            this.ServiceOTPError = 'Please provide a valid OTP.';
                    } else {
                        this.mobileOtpTrails++;
                    }
                    this.showLoader = false;
                },
                    (err) => {
                        console.log('inn');
                        this.showLoader = false;
                        this.mobileOtpTrails++;
                        this.wrongOtpMsg = 'Please provide a valid OTP.';
                    });
        }
    }

    private onResendOTPReceived(mtResponse: ActivitiModel.MTResponse<any>) {
        if (mtResponse.errorBean) {
            this.IsServiceFailure = true;
        }
    }


    public resendOTP(formValue?: FormData) {
        this.healthOtpForm.reset();
        this.IsOTPResend = false;
        if (this.resendOTPCount < 5) {
            this.timerOn = false;
            this.startClockTimer();
            this.timerOn = true;
            this.otpCountDown(60);

            this.generateOTP(this.onResendOTPReceived);

            this.IsOTPResend = true;
            this.resendOTPCount++;
        } else {
            this.resendOtpExceedFlag = true;
        }
    }

    navigateToNextTask() {
        this.showLoader = true;

        this._moreAboutYouCall.PostCallService({ 'action': 'next' }, 'nomineeDetails').subscribe((response: any) => {
            if (response.nextTask) {
                if (response) {
                    const Payload = response.payload;
                    this.setQuotesIs(Payload);
                }
                this._sessionStorage.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, response.nextTask.nextTaskKey);
                this._routerService.RouteToNextTask(response.nextTask.nextTaskKey);
            } else {
                this._sessionStorage.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, response.nextTaskKey);
                this._routerService.RouteToNextTask(response.nextTaskKey);
            }
            this.showLoader = false;
        },
            (error) => {
                this.ServiceError = 'Something went wrong. Please try again later';
                this.showLoader = false;
            });
    }

    public setQuotesIs(Payload) {
        this._sessionStorage.SetSession(CommonConstants.CookieKeys.planQuoteCriteriaData, JSON.stringify(Payload));
    }

    onKeydown(event, prevInput, nextInput) {
        setTimeout(() => {
            if (event.key === 'ArrowLeft' || event.key === 'Backspace') {
                prevInput.focus();
            }
            if (event.key === 'ArrowRight') {
                nextInput.focus();
            }
        }, 50);
    }
    public startClockTimer() {
        clearTimeout(this.setTime);
        this.setTime = setTimeout(() => {
            this.isTimerStarted = false;
        }, 60000);
    }
    public otpCountDown(seconds) {
        let min: any = Math.floor(seconds / 60);
        let sec: any = seconds % 60;
        min = min < 10 ? '0' + min : min;
        sec = sec < 10 ? '0' + sec : sec;
        document.getElementById('timer') ? document.getElementById('timer').innerHTML = min + ':' + sec : '';
        seconds -= 1;
        clearTimeout(this.timer);
        if (seconds >= 0 && this.timerOn) {
            this.timer = setTimeout(() => {
                this.otpCountDown(seconds);
            }, 1000);
            return;
        }
        if (!this.timerOn) {
            return;
        }
    }

    setOTPValue(otpValue) {
        Array.from(otpValue).forEach((x, index) => {
            let counter = index + 1;
            this.healthOtpForm.controls['digit' + counter].setValue(x);
        });
    }

    onPaste(eventData, elem?: HTMLInputElement) {
        this.isOtpPasted = true;
        const clipboardData = eventData.clipboardData;
        const otpValue = clipboardData.getData('text');
        if (/\d{6}/.test(otpValue)) {
            this.setOTPValue(otpValue);
            if (elem) {
                setTimeout(() => {
                    elem.value = otpValue.substr(0, 1);
                    this.healthOtpForm.controls['digit1'].setValue(elem.value);
                    elem.setAttribute('maxlength', '1');
                }, 10);
            }
        } else {
            eventData.preventDefault();
            return false;
        }
    }

    onOTPReceive(elem: HTMLInputElement, eventType: string, digit2?: HTMLInputElement) {
        const osType = this.analyticsService.GetDeviceDetails().os.toLowerCase();
        const isMobileFlag = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile);
        if ((osType === 'android' || osType === 'ios' || isMobileFlag === '1') && !this.isOtpPasted) {
            let digitValue;
            if (eventType === 'input' && elem.value) {
                setTimeout(() => {
                    elem.setAttribute('maxlength', '6');
                    digitValue = elem.value;
                    elem.value = digitValue.substr(0, 1);
                    this.healthOtpForm.controls['digit1'].setValue(elem.value);
                    elem.setAttribute('maxlength', '1');
                    if (/\d{6}/.test(digitValue)) {
                        this.setOTPValue(digitValue);
                    }
                    if (digit2) {
                        digit2.focus();
                    }
                    this.isOtpPasted = false;
                }, 50);
            } else if (eventType === 'click' || eventType === 'focus') {
                elem.setAttribute('maxlength', '6');
            } else if (eventType === 'blur') {
                elem.setAttribute('maxlength', '1');
            }
        }
    }
}
